'use client';

import React, { useEffect, useState } from 'react';
import { cn } from '@/utils/cn';
import Button from '../Button';
import Text from '../Text';
import Icon from '../Icon';
import ButtonLabel from '../Typography/ButtonLabel';

function ReorderAllItemsModal({ onView, onClose }) {
  const [openModal, setOpenModal] = useState(onView);

  useEffect(() => {
    if (onView) {
      setTimeout(() => {
        setOpenModal(true);
      }, 100);
    } else {
      setOpenModal(false);
    }
  }, [onView]);

  const handleClose = (closeState, productAddState) => {
    setOpenModal(closeState);
    setTimeout(() => {
      onClose(closeState, productAddState);
    }, 200);
  };

  return (
    <div
      className={cn(
        'w-full h-full bg-black/30 flex items-center justify-center opacity-0 -z-10 transition-all duration-300 fixed inset-0',
        {
          '!opacity-100 !z-[501]': openModal,
        },
      )}
    >
      <div className="w-full max-w-[480px] mx-8 px-16 lg:px-24 py-10 lg:py-24 relative rounded-[4px] lg:rounded-[12px] transition-all duration-[400ms]">
        <div className="mb-12">
          <Icon
            type="close"
            color="#fff"
            onClick={() => handleClose(false)}
            className="cursor-pointer ml-auto"
          />
        </div>
        <div className="bg-white p-24 rounded-xl shadow-product-slider-shadow">
          <Text
            type="sub_title"
            className="text-fire-chalk text-center text-18 lg:text-20 font-semibold leading-28 tracking-[0.36px] lg:tracking-[0.4px] mb-16"
          >
            Reorder All Items
          </Text>
          <Text
            type="paragraph"
            className="text-coarse-wool text-center text-14 lg:text-16 font-medium leading-20 tracking-[0.28px] lg:tracking-[0.32px] mb-24 px-10"
          >
            Reordered items will merge with the items already in your cart.
            Would you like to proceed?
          </Text>

          <div className="flex justify-between gap-4">
            <Button
              type="outline"
              className="w-full max-w-[208px] mx-auto mt-20 line-clamp-1 !border-tealgreen h-[40px] flex"
              onClick={() => handleClose(false)}
            >
              <ButtonLabel
                label="Go Back"
                className="text-tealgreen text-center font-bold"
              />
            </Button>

            <Button
              type="primary"
              className="w-full max-w-[208px] bg-tealgreen mx-auto mt-20 line-clamp-1 h-[40px] flex hover:bg-cape-verde"
              onClick={() => handleClose(false, true)}
            >
              <ButtonLabel
                label="Continue"
                className="text-white text-center font-bold"
              />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReorderAllItemsModal;
